import { BrowserRouter, Routes, Route } from "react-router-dom";
import VoterSearch from "./pages/VoterSearch";
import VoterSelect from "./pages/VoterSelect";
import Poll from "./pages/Poll";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"       element={<VoterSearch />} />
        <Route path="/select" element={<VoterSelect />} />
        <Route path="/poll"   element={<Poll />} />
      </Routes>
    </BrowserRouter>
  );
}
